import useSWR from "swr";
import { ProcedureLog, Tab } from ".";
import { customFetcher } from "../../../utils";
import VirtualTable from "../../../components/custom/VirtualTable";

export default function Log ({
    data
}: {
    data: Array<ProcedureLog>;
}) {

    return (
        <div>
            <VirtualTable<ProcedureLog> 
                data={data}
                mapping={[{
                    name: 'Name',
                    value: 'name'
                }, {
                    name: 'Run By',
                    value: 'runBy'
                }, {
                    name: 'Date',
                    value: 'date',
                    datetime: true,
                    utc: true
                }, {
                    name: 'Metadata',
                    value: 'metaData'
                }]}
            />
        </div>
    );
}